/* eslint-disable jsx-a11y/alt-text */
import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import React from "react";
import Table from "../../../../../../components/ui/Table/Table";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total, onChangeSelectQR, selectedQR) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexVal =
          page === 1 ? total - index : total - index - (page - 1) * pageSize;

        return <div>{indexVal}</div>;
      },
    }),

    columnHelper.accessor((row) => row.productLotInfo.lotNo, {
      header: "LOT",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.qrNo, {
      header: "QR번호	",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.productLotInfo.manufacDate, {
      header: "제조일자",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? dayjs(val).format("YYYY-MM-DD") : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.productLotInfo.expireDate, {
      header: "유효일자",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? dayjs(val).format("YYYY-MM-DD") : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.qnt, {
      header: "재고수량",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "0"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "선택",
      cell: (info) => {
        const id = info.getValue().id;
        return (
          <div className="flex justify-center">
            <input
              disabled={info?.getValue().qnt === 0}
              type="radio"
              id="qrRadio"
              name="qrRadio"
              className="accent-black"
              onChange={() => onChangeSelectQR(id)}
              checked={selectedQR === id}
            />
          </div>
        );
      },
    }),
  ];
};

export function LotDataByIdTable(props) {
  const { onChangeSelectQR, isEmpty, getDataTableProps, selectedQR } = props;
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().totalAll;

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center">
          등록된 상품이 없습니다.
          <br /> ONEDAY Mall에 상품을 등록하실 경우, '+ 상품등록'을
          진행해주세요.
        </div>
      ) : (
        <>
          <Table
            hasSort={false}
            hasPageSizeFilter={false}
            columns={columns(
              currentPage,
              pageSize,
              totalData,
              onChangeSelectQR,
              selectedQR
            )}
            hasSave={false}
            hasPagination={false}
            {...getDataTableProps()}
          />
        </>
      )}
    </>
  );
}
